import {
  ROUTES,
} from './routes';


export const USER_ROLES =
  Object.freeze({
    ADMIN:
      'ADMIN',

    USER:
      'USER',
  });


const ALL_ROLES =
  Object.freeze([
    USER_ROLES.ADMIN,
    USER_ROLES.USER,
  ]);


export const NAVIGATION_ITEMS =
  Object.freeze([
    {
      id:
        'products',

      translationKey:
        'navigation.products',

      path:
        ROUTES.products,

      homeSection:
        'products',

      roles:
        ALL_ROLES,
    },

    {
      id: 'equipment',
      translationKey: 'equipmentIntro.title',
      path: ROUTES.equipmentIntro,
      homeSection: 'equipment',
      roles: ALL_ROLES,
    },

    {
      id:
        'resources-group',

      translationKey:
        'navigation.resourcesGroup',

      homeSection:
        'resources',

      roles:
        ALL_ROLES,

      children: [
        {
          id:
            'resources',

          translationKey:
            'navigation.resources',

          path:
            ROUTES.resources,

          roles:
            ALL_ROLES,
        },

        {
          id:
            'updatenotices',

          translationKey:
            'navigation.updatenotices',

          path:
            ROUTES.updatenotices,

          roles:
            ALL_ROLES,
        },

        {
          id:
            'success-stories',

          translationKey:
            'navigation.successStories',

          path:
            ROUTES.successStories,

          roles:
            ALL_ROLES,
        },
      ],
    },

    {
      id:
        'customer-service',

      translationKey:
        'navigation.customerService',

      homeSection:
        'customer-service',

      roles:
        ALL_ROLES,

      children: [
        {
          id:
            'elearning',

          translationKey:
            'navigation.elearning',

          path:
            ROUTES.elearning,

          roles:
            ALL_ROLES,
        },

        {
          id:
            'start-now',

          translationKey:
            'navigation.startNow',

          path:
            ROUTES.startNow,

          roles:
            ALL_ROLES,
        },

        {
          id:
            'contact',

          translationKey:
            'navigation.contact',

          path:
            ROUTES.contact,

          roles:
            ALL_ROLES,
        },
      ],
    },

    {
      id:
        'my-info',

      translationKey:
        'navigation.myInfo',

      homeSection:
        'my-info',

      roles:
        ALL_ROLES,

      children: [
        {
          id:
            'account-information',

          translationKey:
            'navigation.memberInfo',

          path:
            ROUTES.memberInfo,

          roles:
            ALL_ROLES,
        },

        {
          id:
            'license-information',

          translationKey:
            'navigation.licenseInfo',

          path:
            ROUTES.licenseInfo,

          roles:
            ALL_ROLES,
        },
      ],
    },
  ]);


export function hasNavigationPermission(
  firstArgument,
  secondArgument,
) {
  let menuItem =
    null;

  if (
    typeof firstArgument ===
      'object' &&
    firstArgument !==
      null &&
    !Array.isArray(
      firstArgument,
    )
  ) {
    menuItem =
      firstArgument;
  } else {
    menuItem =
      secondArgument;
  }

  if (
    !menuItem
  ) {
    return false;
  }

  return true;
}


function filterNavigationItem(
  menuItem,
  role,
) {
  if (
    !hasNavigationPermission(
      menuItem,
      role,
    )
  ) {
    return null;
  }

  if (
    !Array.isArray(
      menuItem.children,
    )
  ) {
    return menuItem;
  }

  const children =
    menuItem.children.filter(
      (
        child,
      ) =>
        hasNavigationPermission(
          child,
          role,
        ),
    );

  return {
    ...menuItem,
    children,
  };
}


export function getNavigationItemsByRole(
  role,
) {
  return NAVIGATION_ITEMS
    .map(
      (
        menuItem,
      ) =>
        filterNavigationItem(
          menuItem,
          role,
        ),
    )
    .filter(
      Boolean,
    );
}


export function getNavigationItems(
  role,
) {
  return getNavigationItemsByRole(
    role,
  );
}


function flattenNavigationItems(
  items,
) {
  return items.flatMap(
    (
      menuItem,
    ) => {
      const currentItem =
        menuItem.path
          ? [
              menuItem,
            ]
          : [];

      if (
        Array.isArray(
          menuItem.children,
        )
      ) {
        return [
          ...currentItem,
          ...flattenNavigationItems(
            menuItem.children,
          ),
        ];
      }

      return currentItem;
    },
  );
}


export function getNavigationItemByPath(
  pathname,
) {
  const normalizedPath =
    String(
      pathname ||
      '/',
    )
      .split(
        '?',
      )[0]
      .replace(
        /\/+$/,
        '',
      ) ||
    '/';

  const flatItems =
    flattenNavigationItems(
      NAVIGATION_ITEMS,
    );

  const sortedItems =
    [
      ...flatItems,
    ].sort(
      (
        left,
        right,
      ) =>
        String(
          right.path ||
          '',
        ).length -
        String(
          left.path ||
          '',
        ).length,
    );

  return (
    sortedItems.find(
      (
        menuItem,
      ) => {
        const menuPath =
          String(
            menuItem.path ||
            '/',
          ).replace(
            /\/+$/,
            '',
          ) ||
          '/';

        return (
          normalizedPath ===
            menuPath ||
          normalizedPath.startsWith(
            `${menuPath}/`,
          )
        );
      },
    ) ||
    null
  );
}


export default NAVIGATION_ITEMS;